import React, { useState, useRef, useEffect } from "react";
import { IconButton, Typography } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import { Link } from "react-router-dom";
import Footer from "../../Footer/Footer";
import Header from "../../Header/MegaMenu";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import "owl.carousel"; // Import Owl Carousel AFTER jQuery
import OwlCarousel from "react-owl-carousel";
import '../outterpages.css'
// import curreciesBan from '../../../assets/Images/Outterpage/currencies-banner-img.webp';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from "@mui/material/styles";
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import Stack from '@mui/material/Stack';
import eng from '../../../assets/Images/Outterpage/eng.webp'
import jap from '../../../assets/Images/Outterpage/jap.webp'
import cardimg from '../../../assets/Images/Outterpage/card-1.webp'
import sec4 from '../../../assets/Images/Outterpage/sec-4-img.webp'
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import commoditiesban from '../../../assets/Images/Outterpage/commodities-banner.webp'
import commoditiescta from '../../../assets/Images/Outterpage/cta-commodites.webp'
import indicesbanner from '../../../assets/Images/Outterpage/indices-banner.webp'

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    borderBottom: "1px solid  rgba(255, 146, 71, 1)  ",
    '&:nth-of-type(odd)': {
        background: "linear-gradient(90deg,rgba(99, 97, 97, 0.44) 15.1%,rgba(70, 69, 68, 0.49) 85.42%)",
    },
    // Hide the last border of the table
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

// const videos = [
//   { id: 1, src: video1 },
//   { id: 2, src: video2 },
//   { id: 3, src: video3 },
//   { id: 3, src: video4 },
// ];
const testimonials = [
    {
        name: "Sherly",
        position: "CEO",
        text: "Figma ipsum component variant main layer. Library figjam subtract font rotate move auto. Figjam strikethrough bullet text device pen scale. Group horizontal link library flows ellipse flatten library undo.",
    },
    {
        name: "Carlos",
        position: "Product Manager",
        text: "An amazing experience! The support and innovation mindset Rishi brings to the team makes every project more exciting and successful.",
    },
    // {
    //   name: "Rishi",
    //   position: "CEO",
    //   text: "Regulus has truly streamlined my trading activity. The platform is incredibly user-friendly, making it easy to navigate and execute trades quickly. I've seen a noticeable improvement in my efficiency!",
    // },
];

const options = {
    margin: 50,
    items: 1,
    autoplay: true,
    autoplayTimeout: 6000,
    dots: false, // Hide default dots
    loop: true,
    smartSpeed: 800,
    nav: true, // We will use custom navigation
    responsive: {
        0: {
            dots: true,
            nav: false,
        },
        768: {
            dots: false,
            nav: true,
        },
    },
};

const marketData = [
    { id: 1, pair: "GBP/USD", value: "1,355.78", trend: "up" },
    { id: 2, pair: "GBP/USD", value: "1,120.65", trend: "down" },
    { id: 3, pair: "GBP/USD", value: "1,120.65", trend: "down" },
    { id: 4, pair: "GBP/USD", value: "1,355.78", trend: "up" },
    { id: 5, pair: "GBP/USD", value: "1,120.65", trend: "down" },
];


const tableData = [
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },

]
const accordianData = [
    {
        question: "What is Finowiz ?",
        answer: "Founded in 2016, Finowiz provides a comprehensive trading environment for Contracts for Difference (CFDs), covering FX currency pairs, stock indexes, metals, and energy. Our clients can trade these CFD products using MetaTrader 4, MetaTrader 5, or via Web Trader. As a global retail brokerage, Finowiz is committed to offering top-tier services to traders worldwide.",
        panel: "panel1"
    },
    {
        question: "Is it mandatory to register my card before making a deposit?",
        answer: "Yes, it is. To enable credit card deposits, you must pre-register your card with Shufti, our automated authentication system, available in the Client Cabinet. If automatic authentication is not possible due to the absence of a camera, you can alternatively send a selfie holding your credit card and ID to our support team via email.",
        panel: "panel2"
    },
    {
        question: "I have invalidated/updated the credit cards utilized for deposits. How can I retrieve the funds?",
        answer: "Even if you have invalidated or renewed the credit/debit card used for a deposit, you can still withdraw funds to the original card. This process depends on the information maintained by the card company. However, specific details may vary, so it is advisable to verify with your card company.",
        panel: "panel3"
    },
    {
        question: "I am unable to transfer funds between accounts.",
        answer: "Fund transfers might be restricted if you have ongoing positions, especially if the transfer amount is equal to or exceeds 90% of your effective margin. Please review the transfer amount and try again",
        panel: "panel4"
    },
    {
        question: "Can I utilize my demo account indefinitely?",
        answer: "Clients with a live account can maintain up to 3 demo accounts without an expiration date. If you wish to set up a demo account with no defined expiry, please contact us with your specific details.",
        panel: "panel5"
    },
    {
        question: "I am encountering difficulties depositing with a credit (debit) card.",
        answer: "Several factors could be causing this issue, such as limitations related to the card type, input errors, browser compatibility, or restrictions set by the card company. Please check your card's status and, if needed, contact your card company to resolve any restrictions.",
        panel: "panel6"
    }
    ,
    {
        question: "Will there be a fee for credit card withdrawals?",
        answer: "No, there are no fees for deposits or withdrawals made with a credit or debit card. For details on fees associated with alternative withdrawal methods, please refer to the provided information",
        panel: "panel7"
    }
    ,
    {
        question: "How does debit card withdrawal differ from credit card refund processing?",
        answer: "While refund procedures are similar for credit and debit cards, there are key differences. Debit card transactions result in immediate deductions from your account. Refunds to debit cards are directly credited back to your bank account.",
        panel: "panel8"
    }
    ,
    {
        question: "Introducing Broker (IB) Program",
        answer: "If you're interested in joining our Introducing Broker (IB) program, please complete our form. For any inquiries about the IB program, contact our partner team at support@finowiz.com.",
        panel: "panel9"
    }
    ,

]
const cardset = [
    {

        head: "Zero Commissions",
        para: "Enjoy trading with no fees and access margins as low as 10%."
    },
    {

        head: "Go Long or Short",
        para: "Take advantage of both rising and falling markets when trading commodities."
    },
    {

        head: "Use Leverage",
        para: "Trade with a fraction of the commodity price, understanding that leverage can amplify both profits and losses."
    },
    {

        head: "User-Friendly Platform",
        para: "Finowiz provides an intuitive and easy-to-use platform designed for seamless commodities trading, catering to both beginners and experienced traders."
    },
    {

        head: "Extensive Commodity Options",
        para: "Access a wide range of commodities, including oil, gold, silver, and more, empowering you to diversify your investments based on your preferences and strategies."
    },
    {

        head: "Favorable Trading Conditions",
        para: "Take advantage of favorable conditions including zero commissions, low margin requirements, and the flexibility to capitalize on both upward and downward market movements. Enhance your profitability and trade execution with Finowiz."
    },

]
const Indicies = () => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const lg = useMediaQuery(theme.breakpoints.up("lg"));
    const md900 = useMediaQuery(theme.breakpoints.up("900"));
    const xl = useMediaQuery(theme.breakpoints.up("xl"));
    const md766 = useMediaQuery(theme.breakpoints.up("766"));
    const [expanded, setExpanded] = React.useState('panel1');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };
    return (
        <div className="OutterPage">
            <Header />
            <div className="bg-outer">
                <section className="banner outter-banner">
                    <div className="contain-width">
                        <Grid container sx={{ alignItems: "flexStart" }}>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} sx={{ placeContent: "center" }}>
                                <div
                                    className="banner-left "
                                    style={{ height: xl ? "500px" : "auto", placeContent: "center" }}
                                >
                                    <p>Indices</p>
                                    <h1 className="mb-30 mt-10">
                                        Indices Trading with <span>Finowiz</span>
                                    </h1>
                                    <p>Explore the world of indices trading with Finowiz, where you can access a diverse range of index instruments to enrich your trading portfolio.</p>
                                    {/* <div
                  className="display-1 btn flex-wrap "
                  style={{ marginBottom: matches ? "40px" : "20px" }}
                >
                  <Link to="/open-new-account" className="bg-btn">
                    Get Started
                  </Link>
                </div> */}
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>

                                <div className="text-center ">
                                    <img width="90%" src={indicesbanner} />
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </section>
                <section className="trade-easy sec-3">
                    <div className="contain-width">
                        <div className="heading">

                            <h2>
                                Why <span>Finowiz?</span>
                            </h2>

                        </div>
                        {/* <div className="heading">
                            <p>
                                <span>Why Finowiz</span>
                            </p>
                            <h2>
                            Achieve Greater Trading Success with <span>Finowiz</span> Indices
                            </h2>
                            <p>
                                Figma ipsum component variant main layer. Prototype share asset stroke distribute star create. Rectangle stroke auto figjam project library select.
                            </p>
                        </div> */}
                        <Grid container spacing={5} >

                            {
                                cardset.map((item) => (
                                    <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }} className="why-choose-card mt-10" sx={{ alignItems: !md900 && "center" }}>
                                        <div>
                                            <img src={cardimg} />
                                        </div>
                                        <p className="mt-10 head"><span className="grd">{item.head}</span></p>
                                        <p className="mt-10">{item.para}</p>

                                    </Grid>
                                ))
                            }



                        </Grid>


                    </div>
                </section>
          
            </div>

            <section class="cta-sec2 out-cta">
                <div className="contain-width">
                    <Grid container spacing={8}>
                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <label>Your Partner in Trading Success</label>
                            <h2 >Register Now for Seamless Trading with Finowiz</h2>
                            {/* <p>
                            Learn to trade without using real money, refining your
                            strategies and learning from mistakes.
                          </p> */}
                            <Link to="#" className="brd-btn" >
                                Register Now
                            </Link>
                        </Grid>
                    </Grid>
                </div>
            </section>



            <Footer />
        </div>
    );
};

export default Indicies;
